import { Button, Card, Typography } from "antd";
import Formatacoes from "../Utils/Formatacao";
import React from "react";
import { Preview } from "./Preview";

export const Download: React.FC<{
    data: Blob, 
    mimetype: string,
    bytes?: number,
    filename?: string

}> = (props) => {
    const { mimetype, data } = props;
    const bytes = props.bytes ?? 0;
    const filename = props.filename ?? "download";

    const salvarBlob = () => {
        const blob = new Blob([data], { type: mimetype });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = filename;
        link.click();

        window.setTimeout(() => {
            URL.revokeObjectURL(downloadUrl);
        }, 100)
    };

    return (
        <div
            style={{
                height: "-webkit-fill-available",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div>
                <Typography style={{ textAlign: "center" }}>
                    <Card style={{ maxWidth: "80vh" }}>
                        <Preview data={data} mimetype={mimetype} />
                    </Card>

                    <Typography.Title type="secondary" level={5}>
                        {filename}
                        <br />
                        {Formatacoes.bytesParaHumanos(bytes)}
                    </Typography.Title>
                </Typography>
            </div>

            <Button onClick={salvarBlob}>Download</Button>
        </div>
    );
};